var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddRoundedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.495,
    height: 35.495,
    viewBox: "0 0 35.495 35.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add_1_",
    "data-name": "add (1)",
    d: "M17.747,0A17.747,17.747,0,1,0,35.495,17.747,17.747,17.747,0,0,0,17.747,0Zm0,32.537A14.789,14.789,0,1,1,32.537,17.747,14.789,14.789,0,0,1,17.747,32.537Zm7.395-14.789a1.479,1.479,0,0,1-1.479,1.479H19.226v4.437a1.479,1.479,0,1,1-2.958,0V19.226H11.832a1.479,1.479,0,1,1,0-2.958h4.437V11.832a1.479,1.479,0,1,1,2.958,0v4.437h4.437A1.479,1.479,0,0,1,25.142,17.747Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRoundedIcon);
export default __webpack_public_path__ + "static/media/addRoundedIcon.b72330a99fde455b3f12418432a8a819.svg";
export { ForwardRef as ReactComponent };